<sm-title-bar pageTitle="Post details" [showBackButton]="true"> </sm-title-bar>
<div class="post-details">
  <sm-crousel [slides]="slides"></sm-crousel>
</div>
<div class="pt-3">
  <div class="heading">
    <h2 class="text-dark m-0">
      {{ postData?.postTitle | uppercase }}
    </h2>
    <span>{{ postData.creationDate | date: "short" }}</span>
  </div>
  <hr />
  <p>
    {{ postData?.description }}
  </p>
</div>
